import { useState } from "react";
import FlagSelector from "../../../components/FlagSelector";
import Sidebar from "../../../components/Sidebar";
import './styles.css'
import {  faCalendarCheck, faCalendarDay, faCheck, faPlus, faPrint, faShare } from "@fortawesome/free-solid-svg-icons";
import SimpleDropDown from "../../../components/SimpleDropDown";
import CustomButton from "../../../components/CustomButton";
import { getStoredJson, saveJsonData, useInitialCheck } from "../../../utils";
import { getDataBaseCondition, getDatabaseRows } from "../../../utils/database";
import CustomCalendar from "../../../components/CustomCalendar";
import lang from "./lang";

import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../contexts/GlobalContext";


export function CalendarPage(){
    const [inspections, setInspections] = useState<any>([])
    const user = getStoredJson('user')

    const { globalOptions, setGlobalOptions } = useGlobalContext()
    const currLang = globalOptions.language

    const navigate = useNavigate()
    useInitialCheck(importInspections)

    async function importInspections(){
        //const response = await getDataBaseCondition('inspections', 'requested_by', user.id)
        let response = await getDatabaseRows('inspections')

        if (user.company != '123456789/0001'){
			response = response.filter((item: any) => item.company == user.company)
		}

        setInspections(response.filter((item: any) => item.approved == 0))
    }

    function handleSelectedClick(selectedEvent: any){
        if(!selectedEvent)
            return

        const data = inspections[selectedEvent.id]
        saveJsonData('pendingInspection', data)
        navigate('/Explore')
    }

    return (
        <div className="MainContainer">
            <FlagSelector/>
            <Sidebar activePage='Home'/>
    
            <div className='SideBarCompensation'/>
            
            <div className='CentralBlock'>
                <div className="itemsContainer">
                    <div className="CalendarSecondRow">
                        <div className="CalendarOptionsContainer">    
                            <CustomButton
                                title={lang.calendar[currLang]}
                                icon={faCheck}
                                containerStyle={{justifyContent: 'flex-start'}}
                            />

                            <CustomButton
                                title={lang.showAll[currLang]}
                                icon={faPlus}
                                containerStyle={{justifyContent: 'flex-start'}}
                                onClick={() => navigate('/Home')}
                            />
                        </div>
        
                        <div className="CalendarContainer">
                            <CustomCalendar inspections={inspections} onClick={handleSelectedClick}/>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    )
}